export function Splash() {
  return <div className="splash"><div className="brand-symbol">C</div><span>LOADING CMOD CANVAS</span></div>
}
